module.exports = __webpack_public_path__ + "static/21-8c09695c344f0a9011951dc38f7c7adb.png";